// @flow

import type {
  CommentOperation,
} from 'hfty-operator-comments/types'

import type {
  Crop,
} from 'fc-model-crops/types'

import type {
  Asset,
} from 'fc-model-assets/types'

// Libs
import React, { Component } from 'react'
import _find from 'lodash/find'
import _round from 'lodash/round'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'

// messages
import {
  messages,
} from 'hfty-comments'

// utils
import traverse from 'fc-utils/traverse'
import { getCropUnit } from 'hfty-utils'

// Components
import { Errors } from 'hfty-components-errors'

// Constants
import {
  PROP_FIELD,
  PROP_CROP,
  PROP_YIELD_TARGET,
  PROP_DATE_CREATED,
} from 'hfty-model-comments'

import {
  PROP_CROP_ID,
  PROP_NAME as PROP_CROP_NAME,
} from 'fc-model-crops'

import {
  PROP_ASSET_ID,
  PROP_LABEL as PROP_ASSET_LABEL,
} from 'fc-model-assets'

// Components
import FormField from '@react-mdc/form-field'

// Styles
import { grey } from 'hfty-styles/src/colors'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    color: grey(0.9),
    margin: '15px 10px',
    padding: '5px 10px',
    borderLeft: 'solid 3px red',
  },
  item: {
    margin: '5px 0',
  },
  title: {
    fontWeight: 500,
    marginRight: 5,
  },
}

type Props = {
  operation: CommentOperation,
  crops: Array<Crop>,
  fields: Array<Asset>,
  currentUserUnits: string,
}

export default class DeleteComment extends Component {
  props: Props

  render (): React.Element<any> {
    const { operation, currentUserUnits } = this.props
    const hasErrors = operation && operation.errors
    const crop = _find(this.props.crops, (crop: Crop): boolean => (
      crop[PROP_CROP_ID] === traverse(['model', PROP_CROP])(operation)
    ))

    const field = _find(this.props.fields, (field: Asset): boolean => (
      field[PROP_ASSET_ID] === traverse(['model', PROP_FIELD])(operation)
    ))
    const dateCreated = traverse(['model', PROP_DATE_CREATED])(operation)
    const targetYield = traverse(['model', PROP_YIELD_TARGET])(operation)

    const cropUnit = getCropUnit(crop, currentUserUnits)

    return (
      <div style={styles.container}>
        <FormField>
          {hasErrors && <Errors errors={operation.errors} />}
        </FormField>
        <div style={styles.item}>
          <span style={styles.title}>
            <FormattedMessage {...messages['crop']} />:
          </span>
          {crop && crop[PROP_CROP_NAME]}
        </div>
        <div style={styles.item}>
          <span style={styles.title}>
            <FormattedMessage {...messages['targetYield']} />:
          </span>
          <span style={{marginRight: 5}}>{_round(targetYield, 2)}</span>
          <FormattedMessage {...messages[cropUnit]} />
        </div>
        <div style={styles.item}>
          <span style={styles.title}>
            <FormattedMessage {...messages['field']} />:
          </span>
          {field && field[PROP_ASSET_LABEL]}
        </div>
        <div style={styles.item}>
          <span style={styles.title}>
            <FormattedMessage {...messages['dateCreated']} />:
          </span>
          {moment.utc(dateCreated).local().format('YYYY-MM-DD hh:mm')}
        </div>
      </div>
    )
  }
}
